import { Logger } from '@x/common/log';
import { TrackingProvider } from '@x/common/tracking';
import { TrackingEvent } from '@x/common/tracking/event-models';
import { IConvertExperimentsConfig } from '@x/common/tracking/providers/convert-experiments/convert-experiments.config';
import { ConvertExperimentsService } from '@x/common/tracking/providers/convert-experiments/convert-experiments.service';

export class ConvertExperimentsProvider extends TrackingProvider {
  constructor(
    private config: IConvertExperimentsConfig,
    private convertExperimentsService: ConvertExperimentsService,
    private logger: Logger,
  ) {
    super();
  }

  async init(): Promise<boolean> {
    try {
      // Initialize immediately without waiting for cookies to avoid blocking site loading
      void this.convertExperimentsService.injectScript(this.config.scriptUrl);
      return true;
    } catch (error) {
      this.logger.error('Error initializing ConvertExperiments provider', error);
      return false;
    }
  }

  sendEvent<T extends object>(event: TrackingEvent<T>): void {
    // ConvertExperiments primarily handles A/B testing via their script
    // No specific event handling needed for now, but this can be extended
    // if ConvertExperiments provides APIs for custom event tracking
  }
}
